import React from 'react';
import { useTranslation } from '../hooks/translate';
import readyToCastImage from '../images/ready-to-cast.svg';
import classNames from 'classnames';
import styles from './ready-to-cast.css';

export const ReadyToCast = ({ skin }) => {
  const [translate] = useTranslation();

  return (
    <>
      <div className={classNames([styles.readyToCast, styles[`ready${skin}`]])}></div>
      <div className={styles.information}>
        <img className={styles.readyIcon} src={readyToCastImage} />
        <span className={styles.text}>{translate('splashReady')}</span>
      </div>
    </>
  );
};
